import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconComment: React.FC<IconProps> = ({ ...props }) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.00002 12C2.00002 6.47715 6.47717 2 12 2C17.5229 2 22 6.47715 22 12C22 17.5228 17.5229 22 12 22C10.4773 22 9.03181 21.659 7.73782 21.0485L3.20105 21.9796C2.87178 22.0472 2.53059 21.9448 2.29291 21.7071C2.05523 21.4694 1.95286 21.1282 2.02043 20.799L2.95147 16.2622C2.34101 14.9682 2.00002 13.5227 2.00002 12ZM9 12C9 12.8284 8.32843 13.5 7.5 13.5C6.67157 13.5 6 12.8284 6 12C6 11.1716 6.67157 10.5 7.5 10.5C8.32843 10.5 9 11.1716 9 12ZM12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5ZM16.5 13.5C17.3284 13.5 18 12.8284 18 12C18 11.1716 17.3284 10.5 16.5 10.5C15.6716 10.5 15 11.1716 15 12C15 12.8284 15.6716 13.5 16.5 13.5Z"
        fill="#200E32"
      />
    </Icon>
  );
};

export default IconComment;
